/* eslint-disable i18next/no-literal-string -- route segments and i18n key segments, not copy */
export const WIZARD_STEPS = ['brief', 'concept', 'script', 'storyboard', 'studio'] as const;

export type WizardStep = (typeof WIZARD_STEPS)[number];

/** The numbered steps in the column. The Studio is reached from the storyboard and has no number. */
export const NUMBERED_STEPS = WIZARD_STEPS.filter((step) => step !== 'studio');

/** The steps a saved reel can be opened on; the others keep a bubble but no screen yet. */
const AVAILABLE_STEPS = [
  'brief',
  'concept',
  'script',
  'storyboard',
  'studio',
] as const satisfies readonly WizardStep[];

export type AvailableStep = (typeof AVAILABLE_STEPS)[number];

export const isAvailableStep = (step: string | undefined): step is AvailableStep =>
  AVAILABLE_STEPS.some((available) => available === step);

/** Where a freshly created reel opens: the brief is done, the concept is next. */
export const FIRST_STEP_AFTER_CREATE: AvailableStep = 'concept';
